// @ts-nocheck
import { Model } from 'backbone';
import Service from 'views/store/common/utility/model/service';
import { Collection } from 'views/store/common/utility/adt/collection';
import Utils from 'views/store/common/utility';

import { ProjectChecklistItemModel } from 'models/store/client/projects/roomchecklists/project_checklist_item';

export class ProjectChecklistModel extends Model {
	static propertiesCustom = ['id', 'projectChecklistId', 'items', 'status', 'display'];

	static initialDisplay = 7;

	static status = {
		OPEN: 'OPEN',
		CLOSED: 'CLOSED',
		DELETED: 'DELETED'
	};

	static new(attributes = {}, options = {}) {
		const _instance = new ProjectChecklistModel();
		_instance.onFetch(attributes, options);
		return _instance;
	}

	defaults() {
		return {
			id: null,
			projectId: null,
			shoppingListGroupId: null,
			selected: false,
			status: ProjectChecklistModel.status.DELETED,
			showMore: true,
			initialDisplay: ProjectChecklistModel.initialDisplay,
			items: new Collection([], { _interface: ProjectChecklistItemModel }),
			display: new Collection([], { _interface: ProjectChecklistItemModel })
		};
	}

	url() {
		return '/app/api';
	}

	initialize(attributes, options) {
		super.initialize(options);
		Service.proxify(this);
	}

	getProperties(...properties) {
		return Utils.pick(this.toJSON(), properties);
	}

	toJSON(options = {}) {
		return {
			id: this.get('id'),
			...Utils.omit(super.toJSON(options), ProjectChecklistModel.propertiesCustom),
			status: this.get('status'),
			selected: this.get('selected'),
			items: this.get('items').toJSON()
		};
	}

	exists() {
		return Utils.defined(this.get('id')) && this.get('status') !== ProjectChecklistModel.status.deleted;
	}

	hasItems() {
		return !this.get('items').isEmpty();
	}

	getStatusValueByKey(value = ProjectChecklistModel.status.deleted) {
		const statusValue = Object.values(ProjectChecklistModel.status).find((current) => current === value);
		return Utils.defined(statusValue) ? statusValue : ProjectChecklistModel.status.DELETED;
	}

	notify(eventName = '') {
		if (Utils.defined(this.collection)) {
			this.collection.trigger(eventName, this);
		}
		return this;
	}

	update() {
		if (this.hasItems()) {
			const numToDisplay = this.get('showMore') ? this.get('initialDisplay') : this.get('items').size();
			this.get('display').set(this.addShowMore(this.get('items').reduce(this.select.bind(this, numToDisplay), [])));
		}
	}

	addShowMore(items = []) {
		if (this.get('showMore')) {
			items.push({ id: 'show-more', name: 'More Categories' });
		}
		return items;
	}

	select(numToDisplay, memo, checklistItem, ix) {
		if (ix < numToDisplay) {
			memo.push({ ...checklistItem.toJSON(), prefix: `${this.get('checklistClass').checklistClass}_` });
		}
		return memo;
	}

	showMore(options = {}) {
		this.set('showMore', false, options);
		return this.update();
	}

	setSelected(selected = false) {
		this.set('selected', selected);
		return this.notify('change:selected');
	}

	load(success, error) {
		return this.request(
			{
				path: `/shoppinglists/v2/checklists`,
				data: JSON.stringify({ ids: [this.get('id')] }),
				contentType: 'application/json',
				onParse: this.onLoad.bind(this)
			},
			success,
			error
		);
	}

	updateStatus(status, success, error) {
		return this.request(
			{
				path: `/shoppinglists/v2/updateChecklistStatus/${this.get('projectId')}/${this.get('shoppingListGroupId')}`,
				type: 'PUT',
				data: JSON.stringify({ projectChecklistId: this.get('id'), status }),
				contentType: 'application/json',
				onParse: this.onFetchStatus.bind(this)
			},
			success,
			error
		);
	}

	onFetch(response = {}, options = {}) {
		if (Utils.defined(response)) {
			this.onFetchId(response, { silent: true });
			this.onFetchStatus(response.status, { silent: true });
			this.onFetchItems(response.items || [], { silent: true });
			this.set(Utils.omit(response, ProjectChecklistModel.propertiesCustom), options).update();
		}
	}

	onLoad(response = []) {
		if (Utils.defined(response) && response.length === 1) {
			this.onFetch(response[0]);
		}
		return {};
	}

	onFetchId(response = {}, options = {}) {
		const id = Utils.defined(response.id) ? response.id : response.projectChecklistId;
		this.set('id', id, options);
		return {};
	}

	onFetchStatus(response = ProjectChecklistModel.status.deleted, options = {}) {
		this.set('status', this.getStatusValueByKey(response), options);
		return {};
	}

	onFetchItems(response = [], options = {}) {
		if (Array.isArray(response) && response.length > 0) {
			this.get('items').set(response, options);
		}
		return {};
	}
}
